import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=01266098&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=01266098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01266098",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01266098')) {
      api.createRecord('01266098', component.options)
    } else {
      api.reload('01266098', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=01266098&scoped=true&", function () {
      api.rerender('01266098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ForgotPassword.vue"
export default component.exports